export default {
    props: {
        gaugeAreaBackground: {
            type: Object,
            default: undefined,
            kComposite: 'gaugeArea.background'
        }, 
        gaugeAreaBorderColor: {
            type: String,
            default: undefined,
            kComposite: 'gaugeArea.border.color'
        }, 
        gaugeAreaBorderDashType: {
            type: String,
            default: undefined,
            kComposite: 'gaugeArea.border.dashType'
        }, 
        gaugeAreaBorderOpacity: {
            type: Number,
            default: undefined,
            kComposite: 'gaugeArea.border.opacity'
        }, 
        gaugeAreaBorderWidth: {
            type: Number,
            default: undefined,
            kComposite: 'gaugeArea.border.width'
        }, 
        gaugeAreaHeight: {
            type: Number,
            default: undefined,
            kComposite: 'gaugeArea.height'
        }, 
        gaugeAreaMargin: {
            type: Number,
            default: undefined,
            kComposite: 'gaugeArea.margin'
        }, 
        gaugeAreaMarginTop: {
            type: Number,
            default: undefined,
            kComposite: 'gaugeArea.margin.top'
        }, 
        gaugeAreaMarginBottom: {
            type: Number,
            default: undefined,
            kComposite: 'gaugeArea.margin.bottom'
        }, 
        gaugeAreaMarginLeft: {
            type: Number,
            default: undefined,
            kComposite: 'gaugeArea.margin.left'
        }, 
        gaugeAreaMarginRight: {
            type: Number,
            default: undefined,
            kComposite: 'gaugeArea.margin.right'
        }, 
        gaugeAreaWidth: {
            type: Number,
            default: undefined,
            kComposite: 'gaugeArea.width'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-gauges-vue-wrapper/src/Common/GaugeArea.js